import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { DiscussionModel } from '@smarttask-common/src/lib/models/Discussion/Core/DiscussionModel';

export enum DiscussionActionTypes {
    ADD_DISCUSSION = '[Discussion] Create Discussion',
    ADD_DISCUSSIONS = '[Discussion] Add Discussions',
    UPSERT_DISCUSSION = '[Discussion] Upsert Discussion',
    UPSERT_DISCUSSIONS = '[Discussion] Upsert Discussions',
    UPDATE_DISCUSSION = '[Discussion] Update Discussion',
    UPDATE_DISCUSSIONS = '[Discussion] Update Discussions',
    DELETE_DISCUSSION = '[Discussion] Delete Discussion',
    DELETE_DISCUSSIONS = '[Discussion] Delete Discussions',
    DELETE_ALL_DISCUSSIONS = '[Discussion] Delete All Discussions',
    DELETE_ALL = '[Discussion] Delete All',

    UPDATE_SELECTED_ID = '[discussion] Update SelectedId',
}

export class UpdateSelectedDiscussionId implements Action {
    readonly type = DiscussionActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_discussion_id: string) {}
}

export class AddOne implements Action {
    readonly type = DiscussionActionTypes.ADD_DISCUSSION;
    constructor(public discussion: DiscussionModel) {}
}

export class AddMany implements Action {
    readonly type = DiscussionActionTypes.ADD_DISCUSSIONS;
    constructor(public discussions: Array<DiscussionModel>) {}
}

export class UpsertOne implements Action {
    readonly type = DiscussionActionTypes.UPSERT_DISCUSSION;

    constructor(public discussion: DiscussionModel) {}
}

export class UpsertMany implements Action {
    readonly type = DiscussionActionTypes.UPSERT_DISCUSSIONS;
    constructor(public discussions: Array<DiscussionModel>) {}
}

export class UpdateOne implements Action {
    readonly type = DiscussionActionTypes.UPDATE_DISCUSSION;
    constructor(public discussion: Update<DiscussionModel>) {}
}

export class UpdateMany implements Action {
    readonly type = DiscussionActionTypes.UPDATE_DISCUSSIONS;
    constructor(public discussions: Array<Update<DiscussionModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = DiscussionActionTypes.DELETE_DISCUSSION;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = DiscussionActionTypes.DELETE_DISCUSSIONS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = DiscussionActionTypes.DELETE_ALL_DISCUSSIONS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = DiscussionActionTypes.DELETE_ALL;
    constructor() {}
}

export type DiscussionActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedDiscussionId;
